import { FdIconProps } from '../types/type'

const UserIcon = ({ width = '1.8rem', height = '1.7rem' }: FdIconProps): JSX.Element => {
  return (
    <svg width={width} height={height} viewBox='0 0 18 17' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M17.0413 16.1877C16.9864 16.2827 16.9075 16.3616 16.8124 16.4165C16.7174 16.4713 16.6096 16.5002 16.4998 16.5002H1.49985C1.39019 16.5001 1.28249 16.4711 1.18757 16.4162C1.09265 16.3613 1.01384 16.2824 0.959062 16.1874C0.904283 16.0924 0.87546 15.9847 0.875488 15.875C0.875516 15.7654 0.904394 15.6576 0.959223 15.5627C2.14907 13.5056 3.98266 12.0306 6.1225 11.3314C5.06404 10.7013 4.24168 9.74117 3.78171 8.59845C3.32174 7.45573 3.2496 6.19361 3.57636 5.00592C3.90313 3.81823 4.61072 2.77064 5.59049 2.02402C6.57026 1.2774 7.76803 0.873047 8.99985 0.873047C10.2317 0.873047 11.4294 1.2774 12.4092 2.02402C13.389 2.77064 14.0966 3.81823 14.4233 5.00592C14.7501 6.19361 14.678 7.45573 14.218 8.59845C13.758 9.74117 12.9357 10.7013 11.8772 11.3314C14.017 12.0306 15.8506 13.5056 17.0405 15.5627C17.0954 15.6576 17.1245 15.7654 17.1246 15.8751C17.1247 15.9848 17.096 16.0926 17.0413 16.1877Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default UserIcon
